<template>
  <div id="pageRoot">
    <img
      id="title"
      class="pageElement"
      src="/pages/img/sordoglo/svgGlo5Title.svg"
    />

    <span class="normalTheme pageInstruction" style="left: 87px; top: 155px">
      <p>
        Completa las preguntas con una palabra.<br />
        Escribe la respueta en la línea.
      </p>
    </span>

    <p id="tag01" class="textBase basicItem01 tagDefault">FLOR</p>
    <p id="tag02" class="textBase basicItem01 tagDefault">RINCÓN</p>
    <p id="tag03" class="textBase basicItem01 tagDefault">CHIMENEA</p>
    <p id="tag04" class="textBase basicItem01 tagDefault">CAMA</p>

    <p id="question01" class="textBase">¿Debajo de la</p>
    <p id="question0101" class="textBase">?</p>

    <p id="question02" class="textBase">¿Vivirá en la</p>
    <p id="question0202" class="textBase">?</p>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="pageElement"
    />
    <!-- SVG ------------------------------------------->
    <img
      id="bed"
      class="pageElement"
      src="/pages/img/sordoglo/svgGlo5Bed.svg"
    />
    <img
      id="chimney"
      class="pageElement"
      src="/pages/img/sordoglo/svgGlo5Chimney.svg"
    />
    <!-- SVG ------------------------------------------->
  </div>
</template>
<style scoped>
#title {
  position: absolute;
  left: 85px;
  top: 57px;
}
#text01 {
  position: absolute;
  width: 588px;
  height: 86px;
  left: 124px;
  top: 145px;
}
#tag01 {
  position: absolute;
  width: 120px;
  text-align: center;
  left: 27px;
  top: 271px;
}
#tag02 {
  position: absolute;
  width: 150px;
  text-align: center;
  left: 250px;
  top: 271px;
}
#tag03 {
  position: absolute;
  width: 180px;
  text-align: center;
  left: 500px;
  top: 271px;
}
#tag04 {
  position: absolute;
  width: 120px;
  left: 778px;
  top: 271px;
  text-align: center;
  text-decoration: line-through;
}

#question01 {
  position: absolute;
  left: 74px;
  top: 458px;
  text-transform: uppercase;
}
#inputField01 {
  position: absolute;
  width: 313px;
  left: 257px;
  top: 445px;
  font-size: 33px;
}
#question0101 {
  position: absolute;
  left: 610px;
  top: 458px;
}
#question02 {
  position: absolute;
  left: 74px;
  top: 628px;
  text-transform: uppercase;
}
#inputField02 {
  position: absolute;
  width: 313px;
  left: 257px;
  top: 610px;
  font-size: 33px;
}
#question0202 {
  position: absolute;
  left: 610px;
  top: 628px;
}
#bed {
  position: absolute;
  left: 653px;
  top: 375px;
}
#chimney {
  position: absolute;
  left: 653px;
  top: 564px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "glo/Video 5b.mp4", 
        "glo/Video 10.mp4", 
        "glo/Video 11b.mp4", 
        "glo/Video 12b.mp4",
        "glo/Video 13.mp4",
        "glo/Video 6.mp4", 
        "glo/Video 7.mp4"]
    }
  }
}
</script>